import { action } from 'mobx';

import { AppManager, Input } from 'core/index';

import { clientStore } from 'apps/client/app';
import { emailValidator } from 'libs/forms/validators';
import { ProfileModel } from 'apps/profile/app';

import { SignInApp } from 'apps/signIn/app';
import { SignInMutation } from 'apps/signIn/gql';

import { SetToken } from 'core/jwt';

export class SignInAppManager extends AppManager {
  static registryName = 'SignInAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.signInApp = new SignInApp(this, {
      usernameEmail: '',
      password: '',
    });
    this.signInApp.init();

    this.signInAppInput = new Input({
      // FIXME
      // eslint-disable-next-line consistent-return
      username: () => {
        const trimmedEmail = this.signInApp.usernameEmail.trim();
        if (!emailValidator(trimmedEmail)) {
          if (!trimmedEmail.startsWith('@')) {
            return `@${trimmedEmail}`;
          }
          return trimmedEmail;
        }
      },
      // FIXME
      // eslint-disable-next-line consistent-return
      email: () => {
        const trimmedEmail = this.signInApp.usernameEmail.trim();
        if (emailValidator(trimmedEmail)) {
          return trimmedEmail;
        }
      },
      password: () => this.signInApp.password,
      signOut: () => this.signInApp.signOut,
    });
    this.signInMutation = new SignInMutation(this.signInAppInput);
    this.signInMutation.process(
      profile => ProfileModel.Load(profile),
      this.SetProfile,
      { subPath: 'profile' },
    );
    this.signInMutation.process(
      token => {
        if (token) SetToken(token);
      },
      () => {},
      { subPath: 'token' },
    );
  }

  @action SetProfile = profileModel => {
    clientStore.SetSignedInProfile(profileModel);
  };

  @action SignIn = options => {
    this.signInApp.signOut = false;
    this.signInMutation.setCallbacks(options);
    const headers = {};
    if (clientStore.HMAC) headers['X-Wikifactory-Hmac'] = clientStore.HMAC;
    this.signInMutation.addHeaders(headers);
    this.signInMutation.mutate();
  };

  @action SignOut = options => {
    this.signInApp.signOut = true;
    this.mutations.push(SignInMutation.New(this.signInAppInput, options));
  };
}
